import './PricingPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { setCompany } from 'containers/Accounts/store/actions';

import H1 from 'components/H1';
import H2 from 'components/H2';
import PricingGrid from 'components/PricingGrid';
import Logo from "../../../../components/Logo";
import Icon from "../../../../components/Icon";
import Button from "../../../../components/Button";

const FEATURES = [
    'Access over 200 marketing freelancers across disciplines',
    'Tap into a diverse, growing network of talent',
    'Unlimited project postings',
    'Real-time messaging within the app',
    'Quick-search filtering by role, industry expertise, or brand experience',
    'Transparent pricing'
];

class PricingPage extends React.Component {
    componentWillMount() {
        document.body.classList.add('pricing-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('pricing-page');
    }

    handleSelectPlanLevel = () => {
        let newCompanyObj = update(this.props.accounts.company, {});
        newCompanyObj.subscriptionTier = 'annual';
        this.props.setCompany(newCompanyObj);
        this.props.changeLocation('/create-your-business-account/form');
    };

    render() {
        return (
            <div className="pricing-page__content">
                <section className="pricing-page__access">
                    <div className="pricing-page__access--inner">
                        <div className="pricing-page__access-content">
                            <H1>
                                Access to all, anytime
                            </H1>
                            <p>
                                Traditional tactics for finding freelance talent not working? Struggling to find reputable creative and marketing freelancers in a pinch? Sick of texting old colleagues for contacts, forking over the commission fees for a recruiter or using a vague online service in hopes that the algorithm fairies would make your freelance wishes come true?
                            </p>
                        </div>
                    </div>
                </section>

                <section className="pricing-page__membership">
                    <div className="pricing-page__membership--inner">

                        <div className="pricing-page__membership-details">
                            <Logo
                                noText
                            />

                            <H1>
                                Membership Details
                            </H1>

                            {FEATURES.map((f) => (
                                <div className="pricing-page__membership-feature">
                                    <Icon type="check" />
                                    {f}
                                </div>
                            ))}

                            <div className="pricing-page__membership-price">
                                $2500 annually
                            </div>

                            <div className="pricing-page__membership-button">
                                <Button
                                    onClick={this.handleSelectPlanLevel}
                                >
                                    Start a free 24-hour trial
                                </Button>
                            </div>
                        </div>

                        <div className="pricing-page__membership-content">
                            <div className="pricing-page__membership-callout">
                                Get a Membership
                            </div>
                            <H2>
                                The better, simpler, go-ahead-and-breathe-easier way to do things
                            </H2>
                            <p>
                                We give businesses immediate access to top-tier marketing and creative freelancers who can get the job done. And not just any freelancer. Vetted freelancers. Trusted freelancers. We’re talking the best of the very, very best freelancers. Are we a recruiting firm? Nah. Another job board? Nope. We just love connecting businesses with the kind of people who can leave their clients downright giddy. Time and time again.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        setCompany: (companyObj) => dispatch(setCompany(companyObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/Signup/PricingPage/index.js